import React from "react";
import Header from "../../sharedComponents/header/header";
import { inject, observer } from "mobx-react";
import "./discountsAndAdditionalClauses.scss";
import AdditionalClauses from "./additionalClauses/additionalClauses";
import { CalculateStore } from "../../../stores/calculateStore";
import { Discounts } from "../../../helpers/discount";
import { UserStore } from "../../../stores/userStore";
import { UserRole } from "../../../helpers/userRole";
import DiscountField from "./discountField/discountField";
import DedicateDiscountCode from "./dedicateDiscountCode/dedicatedDiscountCode";
import OtherClaimlessPolicyDiscount from "./otherClaimlessPolicyDiscount/otherClaimlessPolicyDiscount";
import { UiFlagsStore } from "../../../stores/uiFlagsStore";
import { PolicyStore } from "../../../stores/policyStore";
import { NumberOfDamagesInLastThreeYearsId } from "../../../helpers/additionalQuestions/numberOfDamagesInLastThreeYears";

interface DiscountsAndAdditionalClausesProps {
  calculateStore?: CalculateStore;
  userStore?: UserStore;
  uiFlagsStore?: UiFlagsStore;
  policyStore?: PolicyStore;
}

@inject("calculateStore", "userStore", "uiFlagsStore", "policyStore")
@observer
export default class DiscountsAndAdditionalClauses extends React.Component<DiscountsAndAdditionalClausesProps> {
  public render() {
    return (
      this.props.uiFlagsStore!.isDirect
        ? null
        : <div className="discounts-and-additional-clauses">
          <Header type="medium" mainHeader="Zniżki i postanowienia dodatkowe" />
          <DiscountField discountName={Discounts.agentDiscount} />
          <OtherClaimlessPolicyDiscount />
            {this.displayManagerDiscountDurAgent() && <DiscountField discountName={Discounts.durManagerDiscount}  /> }
            {!this.displayManagerDiscountDurAgent() && <DiscountField discountName={Discounts.managerDiscount} />}
          <DiscountField discountName={Discounts.individualRiskAssessment} />
          {this.displayEmployeeDiscount() && <DiscountField discountName={Discounts.employeeDiscount} />}
          {this.displaySpecialDiscount() && <DiscountField discountName={Discounts.specialDiscount} disabled={this.isDisableSpecialDiscount()} />}
          {this.displayDedicatedDiscount() && <DedicateDiscountCode />}
          {this.displayNnwDiscount() && <DiscountField discountName={Discounts.nnwDiscount} />}
          <AdditionalClauses />
        </div>
    );
  }

  private isDisableSpecialDiscount() {
    const isPolicyRenewal = this.props.policyStore?.isPolicyRenewal;
    const isPropsEnabled = this.props.calculateStore?.additionalQuestions.numberOfDamagesInLastThreeYears.value
      !== NumberOfDamagesInLastThreeYearsId.zero;
    return isPolicyRenewal && isPropsEnabled;
  }

  private displayEmployeeDiscount() {
    const roles = this.props.userStore!.roles;
    const employeeRoles = [UserRole.ZNIZKA_PRACOWNICZA_WSZYSTKIE_TARYFY, UserRole.ZNIZKA_PRACOWNICZA];
    return employeeRoles.some(role => roles?.includes(role));
  }

  private displayNnwDiscount() {
    const roles = this.props.userStore!.roles;
    return roles?.includes(UserRole.ZNIZKA_MARKETINGOWA_NNW_PLUS);
  }

  private displaySpecialDiscount() {
    const roles = this.props.userStore!.roles;
    return roles?.includes(UserRole.ZNIZKA_SPECJALNA) && this.props.policyStore!.isPolicyRenewal;
  }

  private displayDedicatedDiscount() {
    const roles = this.props.userStore!.roles;
    return roles?.includes(UserRole.ZNIZKA_DEDYKOWANA);
  }

  private displayManagerDiscountDurAgent(): boolean {
    const isDurAgent = UserRole.isDurRole(this.props.userStore?.roles);
    this.props.uiFlagsStore?.setIsDurAgent(isDurAgent);

    return this.props.uiFlagsStore?.isDurAgent ?? false;
  }

}
